import {Injectable} from "@angular/core";
import {Actions, createEffect, ofType} from "@ngrx/effects";
import * as hostingRedirectsActions from '../actions/hosting-redirects.action';
import {DbResponse} from "../../shared/interceptors/db-response";
import {filter, map, mergeMap} from 'rxjs/operators';
import {Utils} from "../../shared/utils/utils";
import {LoadRedirects} from '../actions';
import {HostingService} from "../../websites/website/hosting/hosting.service";

@Injectable()
export class HostingRedirectsEffects {

  loadRedirects$ = createEffect(() => this._actions$.pipe(
    ofType(hostingRedirectsActions.LOAD_REDIRECTS),
    mergeMap((action: LoadRedirects) => {
      return this._hostingService.getRedirects(action.payload)
        .pipe(
          filter((response: DbResponse) => !!response),
          map((response: DbResponse) => {
            if (response.success) {
              return new hostingRedirectsActions.LoadRedirectsSuccess({
                websiteId: action.payload,
                entities: Utils.arrayToEntities(response.data, 'id')
              });
            }
            return new hostingRedirectsActions.LoadRedirectsFail(response.message);
          })
        );
    })
  ));

  /* @Effect() updateWebsiteSubData$ = this._actions$.ofType(UPDATE_WEBSITE_SUB_DATA)
     .pipe(
       filter((action: UpdateWebsiteSubData) => !!action.payload.domain_hash),
       map((action: UpdateWebsiteSubData) => {
         return new hostingRedirectsActions.LoadRedirects(action.payload.id);
       })
     );*/

  constructor(
    private _actions$: Actions,
    private _hostingService: HostingService
  ) {
  }


}
